import Vue from 'vue';
import vueHtml2pdf from 'vue-html2pdf';
import jsonCSV from 'vue-json-csv';
import JSZip from 'jszip';

Vue.use(vueHtml2pdf);
Vue.component('json-csv', jsonCSV);
Vue.use(JSZip);
